import { Menu, MenuButton, MenuItems } from '@headlessui/react'

export default function DropDown({ button = null, items, type = 'bordered' }) {
    return (
        <Menu as="div" className="relative inline-block text-left">
            {
                type === 'bordered' ? (
                    <MenuButton className="flex flex-row align-middle items-center gap-x-1.5 bg-inherit text-muted border border-gray-300 py-2 px-3 rounded-md hover:text-secondary shadow-sm hover:bg-gray-50">
                        <span className="fa-regular fa-ellipsis-vertical"></span>
                    </MenuButton>
                ) : type === 'borderless' ? (
                    <MenuButton className="flex flex-row align-middle items-center gap-x-1.5 py-2 px-2 text-muted font-semibold text-gray-500 dark:text-gray-400 disabled:text-slate-400 dark:disabled:text-slate-600 bg-inherit hover:bg-gray-200 data-[open]:bg-gray-200 dark:data-[open]:bg-slate-700 dark:hover:bg-slate-700 rounded-md">
                        <span className="fa-regular fa-ellipsis"></span>
                    </MenuButton>
                ) : (
                    button
                )
            }

            <MenuItems transition className="absolute right-0 z-10 mt-1 origin-top-right rounded-md bg-white dark:bg-slate-900 text-slate-700 dark:text-slate-400 shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in">
                <div className="p-1.5">
                    {
                        items
                    }
                </div>
            </MenuItems>
        </Menu>
    )
}
